"use client";

import { motion } from 'framer-motion';

export function AboutWhySection() {
  return (
    <section className="py-24 bg-gradient-to-br from-thistle-100 to-blue-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-4xl mx-auto"
        >
          <h2 className="text-h2 mb-6">Warum wir Umynd gegründet haben</h2>
          <p className="text-body-lg text-left">
            Wir sind der Ansicht, dass niemand die heutigen Rekrutierungsprozesse verdient hat: weder Kandidaten, noch Recruiter. Die strukturelle Überforderung des Prozesses hinterlässt bei allen Beteiligten Frustration und Enttäuschung. 
          </p>
          <p className="text-body-lg mt-4 text-left">
            Wir sind zutiefst davon überzeugt, dass künstliche Intelligenz das Mittel bietet, den Prozess der Anbahnung und Verwirklichung von Beschäftigungsverhältnissen persönlicher und personalisierter zu gestalten. Künstliche Intelligenz sorgt dafür, dass mehr Bewerber eine faire Chance bekommen, dass Fähigkeiten besser erkannt und gematcht werden, dass Entscheidungen objektiver getroffen werden können. Sie macht, paradoxerweise, das Recruiting-Erlebnis wieder &quot;menschlich&quot; - zum Besten von Kandidaten und Unternehmen.
          </p>
          <p className="text-body-lg mt-4 text-left">
            Wir haben ein tiefes Verständnis für die exponentielle Entwicklung, die KI aktuell und auf absehbare Zeit nimmt. Wir antworten auf diese Entwicklung, indem wir kein statisches &quot;Tool&quot; entwickeln und als &quot;Produkt&quot; verkaufen. Wir integrieren vielmehr agil und pragmatisch die jeweils aktuellsten Möglichkeiten, verbinden sie mit menschlicher Expertise und Erfahrung und stellen diesen Service unseren Kunden zur Verfügung.
          </p>
        </motion.div>
      </div>
    </section>
  );
} 